(function () {
    "use strict";

    angular.module("app").controller("SecurityIncidentsDetailsController", SecurityIncidentsDetailsController);

    SecurityIncidentsDetailsController.$inject = [
        "$attrs",
        "controllerDecorator", "securityIncidentsApi"
    ];
    function SecurityIncidentsDetailsController(
        $attrs,
        controllerDecorator, securityIncidentsApi
    ) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation", "dialog"]);

        const publicId = $attrs.publicId;

        vm.data = null;
        vm.searchUsersForPerson = searchUsersForPerson;
        vm.$onInit = initialize;

        function initialize() {
            vm.SetLoadingState(true);

            securityIncidentsApi.Get(publicId, ({ data: securityIncident }) => {
                vm.data = securityIncident;

                vm.SetLoadingState(false);
            });
        }

        function searchUsersForPerson(person) {
            vm.Navigator.Search.OpenSearchUsersByKeywords(person.DossierPerson.ReferenceNbr);
        }
    }
})();
